import { Status } from '@essent/common';
import { createSelector } from '@ngrx/store';

import { getFlowIdHasError, getFlowIdString } from '../flow/flow-id.selectors';
import { getRetentionState } from '../retention-feature.selector';

export const getAddressState = createSelector(
  getRetentionState,
  (state) => state.supplyAddress
);

export const getAddressEntry = createSelector(
  getAddressState,
  getFlowIdString,
  (state, flowId) => (flowId != null ? state.entities[flowId] : undefined)
);

export const getAddress = createSelector(
  getAddressEntry,
  (entry) => entry?.entry
);

export const getAddressStatus = createSelector(
  getAddressEntry,
  (entry) => entry?.status
);

export const getAddressHasError = createSelector(
  getAddressStatus,
  getFlowIdHasError,
  (status, hasFlowIdError) => status === Status.ERROR || hasFlowIdError
);

export const isAddressLoading = createSelector(
  getAddressStatus,
  getAddressHasError,
  (status, hasError) =>
    (status === undefined ||
      status === Status.PENDING ||
      status === Status.IDLE) &&
    !hasError
);

export const getSupplyAddressVM = createSelector(getAddress, (entry) =>
  entry != null
    ? {
        postcode: entry?.postcode || '',
        houseNumber: entry?.houseNumber || '',
        houseNumberExtension: entry?.houseNumberExtension,
        street: entry?.street || '',
        city: entry?.city || '',
      }
    : undefined
);
